import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import Login from '@/views/Login.vue'
import Signin from '@/views/Signin.vue'
import utils from '@/utils/utils'
const proto = Vue.prototype
import storage from '@/utils/storage'

Vue.use(Router)

const router = new Router({
  base: 'desk4me',
  mode: 'history',
  routes: [
    {
      path: '/desk/booking',
      name: 'DeskBook',
      component: () => import('@/views/DeskBooking.vue'),
      meta: {
        features: {
          hasBookingForDesk: true
        }
      }
    },
    {
      path: '/desk/team/booking',
      name: 'DeskTeamBook',
      component: () => import('@/views/DeskTeamBooking.vue'),
      meta: {
        features: {
          hasBookingForDesk: true
        },
        roles:{
          client: true,
          teamManager: true
        }
      }
    },
    {
      path: '/desk/booking/invite/:inviteId',
      name: 'InviteDeskBooking',
      component: () => import('@/views/InviteDeskBooking.vue'),
      meta: {
        features: {
          hasBookingForDesk: true
        }
      }
    },
    {
      path: '/space/occupancy',
      name: 'SpaceOccupancy',
      component: () => import('@/views/SpaceOccupancy.vue'),
      meta: {
        features: {
          hasBookingForDesk: true
        }
      }
    },
    {
      path: '/locker/booking',
      name: 'LockerBook',
      component: () => import('@/views/LockerBooking.vue'),
      meta: {
        features: {
          hasBookingForLocker: true
        }
      }
    },
    {
      path: '/restaurant/booking',
      name: 'RestaurantBook',
      component: () => import('@/views/RestaurantBooking.vue'),
      meta: {
        features: {
          hasBookingForRestaurant: true
        }
      }
    },
    {
      path: '/chartered/booking',
      name: 'CharteredBook',
      component: () => import('@/views/CharteredBooking.vue'),
      meta: {
        features: {
          hasBookingForChartered: true
        }
      }
    },
    {
      path: '/parking/booking',
      name: 'ParkingBook',
      component: () => import('@/views/ParkingBooking.vue'),
      meta: {
        features: {
          hasBookingForParking: true
        }
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        fullScreen: true,
        disableAuth: true
      }
    },
    {
      path: '/signin',
      name: 'SignIn',
      component: Signin,
      meta: {
        fullScreen: true,
        disableAuth: true
      }
    },
    {
      path: '/admin/settings/site/:id',
      name: 'SiteSettings',
      component: () => import('@/views/admin/SiteSettings'),
      meta: {
        roles:{
          client: true,
          site: true,
          settings: true
        }
      }
    },
    {
      path: '/admin/sites',
      name: 'Sites',
      component: () => import('@/views/admin/Sites'),
      meta: {
        roles:{
          site: {
            edit: false
          },
          client: {
            edit: false
          },
          settings: {
            edit: false
          }
        }
      }
    },
    {
      path: '/admin/regions',
      name: 'Regions',
      component: () => import('@/views/admin/Regions'),
      meta: {
        globalAdminUrlOnly: true,
        features: {
          hasBookingForDesk: true
        },
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/region/:regionId/desks',
      name: 'Desks',
      component: () => import('@/views/admin/Desks'),
      meta: {
        globalAdminUrlOnly: true,
        features: {
          hasBookingForDesk: true
        },
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/region/:regionId/lockers',
      name: 'Lockers',
      component: () => import('@/views/admin/Lockers'),
      meta: {
        globalAdminUrlOnly: true,
        features: {
          hasBookingForLocker: true
        }
      }
    },
    {
      path: '/admin/restaurants',
      name: 'Restaurants',
      component: () => import('@/views/admin/Restaurants'),
      meta: {
        globalAdminUrlOnly: true,
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/restaurant/:id/integration',
      name: 'ManageRestaurantIntegration',
      component: () => import('@/views/admin/ManageRestaurantIntegration'),
      meta: {
        globalAdminUrlOnly: true,
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/chartered',
      name: 'Chartered',
      component: () => import('@/views/admin/Chartered'),
      meta: {
        globalAdminUrlOnly: true,
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/parkings',
      name: 'Parkings',
      component: () => import('@/views/admin/Parkings'),
      meta: {
        globalAdminUrlOnly: true,
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/parking/:id/integration',
      name: 'ManageParkingIntegration',
      component: () => import('@/views/admin/ManageParkingIntegration'),
      meta: {
        globalAdminUrlOnly: true,
        roles:{
          client: true,
        }
      }
    },
    {
      path: '/admin/manage/booking',
      name: 'ManageBooking',
      component: () => import('@/views/admin/ManageBooking'),
      meta: {
        features: {
          hasBookingForDesk: true
        },
        roles:{
          client: true,
          settings: true,
          hostess: true
        }
      }
    },
    {
      path: '/admin/manage/parkingBooking',
      name: 'ManageParkingBooking',
      component: () => import('@/views/admin/ManageParkingBooking'),
      meta: {
        features: {
          hasBookingForParking: true
        },
        roles:{
          client: true,
          settings: true,
          hostess: true
        }
      }
    },
    {
      path: '/admin/manage/restaurantBooking',
      name: 'ManageRestaurantBooking',
      component: () => import('@/views/admin/ManageRestaurantBooking'),
      meta: {
        features: {
          hasBookingForRestaurant: true
        },
        roles:{
          client: true,
          settings: true,
          hostess: true
        }
      }
    },
    {
      path: '/admin/manage/charteredBusBooking',
      name: 'ManageCharteredBusBooking',
      component: () => import('@/views/admin/ManageCharteredBusBooking'),
      meta: {
        features: {
          hasBookingForChartered: true
        },
        roles:{
          client: true,
          settings: true,
          hostess: true
        }
      }
    },
    {
      path: '/admin/manage/lockerBooking',
      name: 'ManageLockerBooking',
      component: () => import('@/views/admin/ManageLockerBooking'),
      meta: {
        features: {
          hasBookingForLocker: true
        },
        roles:{
          client: true,
          settings: true,
          hostess: true
        }
      }
    },
    {
      path: '/admin/dashboards/desk',
      name: 'DashboardDeskReport',
      component: () => import('@/views/admin/DashboardDeskReport'),
      meta: {
        features: {
          hasBookingForDesk: true,
          hasMonitoring: true
        },
        roles:{
          client: true,
          reports: true
        }
      }
    },
    {
      path: '/admin/dashboards/monitoring',
      name: 'DashboardMonitoringReport',
      component: () => import('@/views/admin/DashboardMonitoringReport'),
      meta: {
        features: {
          hasMonitoring: true
        },
        roles:{
          client: true,
          reports: true
        }
      }
    },
    {
      path: '/admin/dashboards/comfort',
      name: 'DashboardComfortReport',
      component: () => import('@/views/admin/DashboardComfortReport'),
      meta: {
        features: {
          hasComfort: true
        },
        roles:{
          client: true,
          reports: true
        }
      }
    },
    {
      path: '/admin/dashboards/chartered',
      name: 'DashboardCharteredReport',
      component: () => import('@/views/admin/DashboardCharteredReport'),
      meta: {
        features: {
          hasBookingForChartered: true
        },
        roles:{
          client: true,
          reports: true
        }
      }
    },
    {
      path: '/admin/dashboards/parking',
      name: 'DashboardParkingReport',
      component: () => import('@/views/admin/DashboardParkingReport'),
      meta: {
        features: {
          hasBookingForParking: true
        },
        roles:{
          client: true,
          reports: true
        }
      }
    },
    {
      path: '/admin/dashboards/restaurant',
      name: 'DashboardRestaurantReport',
      component: () => import('@/views/admin/DashboardRestaurantReport'),
      meta: {
        features: {
          hasBookingForRestaurant: true
        },
        roles:{
          client: true,
          reports: true
        }
      }
    },
    {
      path: '/admin/reports/desk',
      name: 'DeskReport',
      component: () => import('@/views/admin/DeskReport'),
      meta: {
        features: {
          hasBookingForDesk: true
        },
        roles:{
          client: true,
          teamManager: true,
          people: true,
          reports: true,
          hostess: true
        }
      }
    },
    {
      path: '/admin/reports/chartered',
      name: 'CharteredReport',
      component: () => import('@/views/admin/CharteredReport'),
      meta: {
        features: {
          hasBookingForChartered: true
        },
        roles:{
          client: true,
          teamManager: true,
          people: true,
          reports: true,
          hostess: true
        }
      }
    },
    {
      path: '/admin/reports/maps',
      name: 'LocationMap',
      component: () => import('@/views/admin/LocationMap'),
      meta: {
        features: {
          hasBookingForDesk: true
        },
        roles:{
          client: true,
          reports: true
        }
      }
    },
    {
      path: '/admin/reports/anotherPersonAndGuest',
      name: 'AnotherPersonAndGuestReport',
      component: () => import('@/views/admin/AnotherPersonAndGuestReport'),
      meta: {
        features: {
          hasBookingForDesk: true
        },
        roles:{
          client: true,
          teamManager: true,
          people: true,
          reports: true,
          hostess: true
        }
      }
    },
    {
      path: '/admin/reports/parking',
      name: 'ParkingReport',
      component: () => import('@/views/admin/ParkingReport'),
      meta: {
        features: {
          hasBookingForParking: true
        },
        roles:{
          client: true,
          teamManager: true,
          people: true,
          reports: true,
          hostess: true
        }
      }
    },
    {
      path: '/admin/reports/restaurant',
      name: 'RestaurantReport',
      component: () => import('@/views/admin/RestaurantReport'),
      meta: {
        features: {
          hasBookingForRestaurant: true
        },
        roles:{
          client: true,
          teamManager: true,
          people: true,
          reports: true,
          hostess: true
        }
      }
    },
    {
      path: '/admin/reports/locker',
      name: 'LockerReport',
      component: () => import('@/views/admin/LockerReport'),
      meta: {
        features: {
          hasBookingForLocker: true
        },
        roles:{
          client: true,
          teamManager: true,
          people: true,
          reports: true,
          hostess: true
        }
      }
    },
    {
      path: '/admin/manage/service',
      name: 'MonitoringReport',
      component: () => import('@/views/admin/ServiceDesk'),
      meta: {
        roles:{
          client: true,
          service: true,
          hostess: true
        }
      }
    },
    {
      path: '/admin/groups/desks',
      name: 'DeskGroups',
      component: () => import('@/views/admin/DeskGroups'),
      meta: {
        features: {
          hasBookingForDesk: true,
          hasMonitoring: true
        },
        roles:{
          client: true,
          group: true,
          site: true
        }
      }
    },
    {
      path: '/admin/groups/desks/create',
      name: 'DeskGroups',
      component: () => import('@/views/admin/ManageDeskGroups'),
      meta: {
        features: {
          hasBookingForDesk: true,
          hasMonitoring: true
        },
        roles:{
          client: true,
          group: true,
          site: true,
        }
      }
    },
    {
      path: '/admin/groups/desks/edit/:id',
      name: 'DeskGroups',
      component: () => import('@/views/admin/ManageDeskGroups'),
      meta: {
        features: {
          hasBookingForDesk: true,
          hasMonitoring: true
        },
        roles:{
          client: true,
          group: true,
          site: true
        }
      }
    },
    {
      path: '/admin/service/types',
      name: 'ServiceDeskTypes',
      component: () => import('@/views/admin/ServiceDeskType'),
      meta: {
        roles:{
          client: true
        }
      }
    },
    {
      path: '/admin/meal/types',
      name: 'MealTypes',
      component: () => import('@/views/admin/MealType'),
      meta: {
        features: {
          hasBookingForRestaurant: true
        },
        roles:{
          client: true,
          settings: true,
        }
      }
    },
    {
      path: '/admin/meal/types/add',
      name: 'MealTypes',
      component: () => import('@/views/admin/ManageMealType'),
      meta: {
        features: {
          hasBookingForRestaurant: true
        },
        roles:{
          client: true,
          settings: true,
        }
      }
    },
    {
      path: '/admin/meal/types/edit/:id',
      name: 'MealTypes',
      component: () => import('@/views/admin/ManageMealType'),
      meta: {
        features: {
          hasBookingForRestaurant: true
        },
        roles:{
          client: true,
          settings: true,
        }
      }
    },
    {
      path: '/admin/meal/dishes/add',
      name: 'MealTypes',
      component: () => import('@/views/admin/ManageDishes'),
      meta: {
        features: {
          hasBookingForRestaurant: true
        },
        roles:{
          client: true,
          settings: true,
        }
      }
    },
    {
      path: '/admin/meal/dishes/edit/:id',
      name: 'MealTypes',
      component: () => import('@/views/admin/ManageDishes'),
      meta: {
        features: {
          hasBookingForRestaurant: true
        },
        roles:{
          client: true,
          settings: true,
        }
      }
    },
    {
      path: '/admin/meal/menus',
      name: 'MealMenus',
      component: () => import('@/views/admin/MealMenus'),
      meta: {
        features: {
          hasBookingForRestaurant: true
        },
        roles:{
          client: true,
          settings: true,
        }
      }
    },
    {
      path: '/admin/desk/attributes',
      name: 'DeskAttributes',
      component: () => import('@/views/admin/DeskAttributes'),
      meta: {
        features: {
          hasBookingForDesk: true
        },
        roles:{
          client: true
        }
      }
    },
    {
      path: '/admin/qrcodes',
      name: 'QrCodes',
      component: () => import('@/views/admin/QrCodes'),
      meta: {
        globalAdminUrlOnly: true,
        noClientInfoRequired: true
      }
    },
    {
      path: '/*',
      name: 'Error',
      component: () => import('@/views/Error'),
      meta: {
        hideLoading : true
      }
    }
  ]
})

const getClientAdminFromSession = async (to) => {
  let obj = {
    clientId: storage.getFromLocalStorage('clientIdDesk4Me'),
    originalClientId: storage.getFromLocalStorage('originalDesk4MeId')
  }
  const clientId = store.getters['Client/clientId']
  if((!clientId || (clientId !== obj.clientId)) && !to.meta.noClientInfoRequired) {
    await store.dispatch('Client/setClientAdmin', obj, {root: true})
    await store.dispatch('Global/updateInitialSettings', null, {root: true})
  }
}

const checkAdminUrlFeaturesAndNavigate = async (to, from, next) => {
  if (store.getters['Auth/isGlobalAdminHostname']) {
    await getClientAdminFromSession(to)
    if ((to.meta.globalAdminUrlOnly !== undefined && !to.meta.globalAdminUrlOnly) && !to.meta.disableAuth && store.getters['Client/originalClientId'] === null && to.path !== '/notFound') {
      next({path: '/'})
    }
  } else if (!store.getters['Auth/isGlobalAdminHostname']) {
    if (to.meta.globalAdminUrlOnly) {
      next({path: '/notFound'})
    }
  }
  //check features to allow router
  if(utils.checkFeatureInRoute(to.meta.features, store.getters['Global/hasProduct'])){
    next()
  } else {
    next({path: '/notFound'})
  }
}

const checkAdminRole = (to) => {
  let isAllowed = false
  if(to.meta.roles){
      for(var roleInRoute in to.meta.roles){
        let available =  (store.getters['Auth/role'] && store.getters['Auth/role'].some( role => role === proto.$rolesDesk4me.rolesWithoutGroup[roleInRoute])) || store.getters['Auth/isGlobalAdmin']
        if(available){
          isAllowed = true
        }
      }
  }
  return isAllowed
}

const isRoleAllowed = (to) => {
  if(checkAdminRole(to)){
    return true
  }
  if (to.meta.hasBookingForGuests) {
    const siteHasBookingForGuests = getSiteConfigsHasBookingForGuests()
    return ((store.getters['Global/hasBookingForGuests'] || siteHasBookingForGuests))
  }
  if (to.meta.globalAdminUrlOnly) {
    if (store.getters['Auth/isGlobalAdmin']) {
      return true
    } else {
      return false
    }
  }
  if (to.path.includes('admin')) {
    return false
  }
  return true
}

const checkRole = async (to, from, next) => {
  if (isRoleAllowed(to, from, next)) {
    checkAdminUrlFeaturesAndNavigate(to, from, next)
  } else {
    next('/notFound')
  }
}

const checkLoading = (to) => {
  if (to.meta.hideLoading) {
    store.dispatch('Global/hideLoading', null, {root: true})
  }
}

const getSiteConfigsHasBookingForGuests = () => {
  const siteConfigs = store.getters['Global/initialSettingsSiteConfigs']
  return siteConfigs.some(x => x.hasBookingForGuests === true)
}

router.beforeEach(async (to, from, next) => {
  if (store.getters['Auth/isAuthenticated']) {
    // already signed in, we can navigate anywhere
    await checkRole(to, from, next)
    checkLoading(to)
  } else if (!to.meta.disableAuth) {
    // authentication is required. Trigger the sign in process
    await store.dispatch('Auth/authenticate')
    if(store.getters['Auth/isAuthenticated']){
      await checkRole(to, from, next)
      checkLoading(to)
    } else {
      next({path: '/login'})
    }
  } else {
    // No auth required. We can navigate
    await checkRole(to, from, next)
    checkLoading(to)
  }
})
// eslint-disable-next-line no-unused-vars
router.afterEach(async (to, from) => {
  window.gtag('config', process.env.VUE_APP_GT_TAG, {
    'page_title': to.name,
    'page_path': to.path
  })
  window.cx.tracking('send', 'screen', to.name)
})



export default router
